import React from 'react'
import { BigTechHiring } from '../Trends/BigTechHiring'

function BigTechHirings() {
  return (
    <>
        <BigTechHiring />
    </>
  )
}

export default BigTechHirings
